import { Mapper } from './mapper';

export const NaturezaAtividade = Mapper.from([
  [1, 'Trabalho urbano'],
  [2, 'Trabalho rural'],
]);
